import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Divider,
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { preetidirector } from "../../iconsImports";

const InvoiceViewModal = ({ open, onClose, invoice }) => {
  if (!invoice) return null;

  const total = parseFloat(invoice.amount);
  const tax = (total * invoice.tax_rate) / 100;
  const grandTotal = total + tax;
const numberToWords = (num) => {
  const a = [
    '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
    'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen',
    'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen',
  ];
  const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  const inWords = (n) => {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? ' ' + a[n % 10] : '');
    if (n < 1000) return a[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' and ' + inWords(n % 100) : '');
    if (n < 100000) return inWords(Math.floor(n / 1000)) + ' Thousand' + (n % 1000 ? ' ' + inWords(n % 1000) : '');
    if (n < 10000000) return inWords(Math.floor(n / 100000)) + ' Lakh' + (n % 100000 ? ' ' + inWords(n % 100000) : '');
    return inWords(Math.floor(n / 10000000)) + ' Crore' + (n % 10000000 ? ' ' + inWords(n % 10000000) : '');
  };

  const rupees = Math.floor(num);
  const paise = Math.round((num - rupees) * 100);
  const rupeesInWords = inWords(rupees) + ' Rupees';
  const paiseInWords = paise ? ' and ' + inWords(paise) + ' Paise' : '';
  return rupeesInWords + paiseInWords + ' Only';
};

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent>
        <Box
          sx={{
            border: "1px solid black",
            maxWidth: "800px",
            margin: "auto",
            backgroundColor: "#fff",
          }}
        >
          {/* Header Row */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="body2">
              <strong>GSTIN:07AAKCB0198F1Z0</strong> 
            </Typography>
            <Typography  sx={{fontWeight:"bold"}}>
              Original Copy
            </Typography>
          </Box>

          {/* Company Name */}
          <Box textAlign="center" mb={2}>
            <Typography variant="h5" fontWeight="bold">Tax Invoice</Typography>
            <Typography variant="h5" fontWeight="bold">
              BiggBrains Solutions Pvt. Ltd.
            </Typography>
            <Typography variant="body2">
              Flat No. 111, First Floor, Pocket-13,
              <br />
              ROHINI POOTH KALAN, DELHI-110086
              <br />
              CIN: U72200DL2021PTC384296
            </Typography>
          </Box>

          {/* Box with 4 sections */}
          <Box
            sx={{
              borderTop: "1px solid black",
              borderBottom: "1px solid black",
              mb: 3, // more space below GST section
              width: "100%",
            }}
          >
            <Grid container spacing={0}>
              {/* Invoice No. / GR/RR No. */}
              <Grid item xs={6} sx={{ borderRight: "1px solid black", p: 0.5 }}>
                {[
                  { label: "Invoice No", value: invoice.invoice_no },
                  { label: "Dated", value: invoice.invoice_date },
                  { label: "Place of Supply", value: "Haryana (06)" },
                  { label: "Reverse Charge", value: "No" },
                ].map(({ label, value }) => (
                  <Box key={label} sx={{ display: "flex", alignItems: "center" }}>
                    <Typography sx={{ flex: 1, fontWeight: "bold" }}>{label}</Typography>
                    <Typography sx={{ width: "10px", textAlign: "center" }}>:</Typography>
                    <Typography sx={{ flex: 1, fontSize: "12px" }}>{value}</Typography>
                  </Box>
                ))}
              </Grid>

              {/* Transport Details */}
              <Grid item xs={6} sx={{ p: 0.5 }}>
                {[
                  { label: "GR/RR No", value: invoice.gr_rr_no || "" },
                  { label: "Transport", value: invoice.transport || "" },
                  { label: "Vehicle No", value: invoice.vehicle_no || "" },
                  { label: "Station", value: "Faridabad" },
                ].map(({ label, value }) => (
                  <Box key={label} sx={{ display: "flex", alignItems: "center" }}>
                    <Typography sx={{ flex: 1, fontWeight: "bold" }}>{label}</Typography>
                    <Typography sx={{ width: "10px", textAlign: "center" }}>:</Typography>
                    <Typography sx={{ flex: 1 }}>{value}</Typography>
                  </Box>
                ))}
              </Grid>

              {/* Billed To */}
              <Grid item xs={6} sx={{ borderTop: "1px solid black", borderRight: "1px solid black", p: 1 }}>
                {[
                  { label: "Billed To", value: invoice.establishment || "" },
                  { label: "GSTIN/UIN", value: invoice.gst || "" },
                ].map(({ label, value }) => (
                  <Box key={label} sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
                    <Typography sx={{ flex: 1, fontWeight: "bold" }}>{label}</Typography>
                    <Typography sx={{ width: "10px", textAlign: "center" }}>:</Typography>
                    <Typography sx={{ flex: 1, whiteSpace: "pre-wrap" }}>{value}</Typography>
                  </Box>
                ))}
              </Grid>

              {/* Shipped To */}
              <Grid item xs={6} sx={{ borderTop: "1px solid black", p: 1 }}>
                {[
                  { label: "Shipped To", value: invoice.establishment || "" },
                  { label: "GSTIN/UIN", value: invoice.gst || "" },
                ].map(({ label, value }) => (
                  <Box key={label} sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
                    <Typography sx={{ flex: 1, fontWeight: "bold" }}>{label}</Typography>
                    <Typography sx={{ width: "10px", textAlign: "center" }}>:</Typography>
                    <Typography sx={{ flex: 1, whiteSpace: "pre-wrap" }}>{value}</Typography>
                  </Box>
                ))}
              </Grid>
            </Grid>
          </Box>

          {/* Goods Table */}
        <TableContainer component={Paper} sx={{ mb: 2 }}>
  <Table
    size="small"
    sx={{
      borderTop: "1px solid black",
      borderBottom: "1px solid black",

    }}
  >
  <TableHead>
  <TableRow>
    {[
      "S.No",
      "Description of Goods",
      "HSN/SAC Code",
      "Quantity",
      "Unit",
      "Price",
      "Amount",
    ].map((heading) => (
      <TableCell
        key={heading}
        sx={{
          borderBottom: "1px solid black", // Adds full box-style borders
          borderRight:"1px solid black",
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        {heading}
      </TableCell>
    ))}
  </TableRow>
</TableHead>

 <TableBody>
  <TableRow>
    <TableCell sx={{ borderTop: "1px solid black", borderRight: "1px solid black", textAlign: "center" }}>1</TableCell>
    <TableCell sx={{ borderTop: "1px solid black", borderRight: "1px solid black" }}>{invoice.description}</TableCell>
    <TableCell sx={{ borderTop: "1px solid black", textAlign: "center" }}>
      {invoice.hsn_sac_code || "-"}
    </TableCell>
    <TableCell sx={{ border: "1px solid black", textAlign: "center" }}>{invoice.qty}</TableCell>
    <TableCell sx={{ border: "1px solid black", textAlign: "center" }}>{invoice.unit || "-"}</TableCell>
    <TableCell sx={{ border: "1px solid black", textAlign: "right" }}>
      ₹{parseFloat(invoice.price).toFixed(2)}
    </TableCell>
    <TableCell sx={{ border: "1px solid black",borderRight:"none", textAlign: "right" }}>
      ₹{total.toFixed(2)}
    </TableCell>
  </TableRow>

  {/* Subtotal Row */}
  <TableRow>
    {/* <TableCell colSpan={6} sx={{ border: "1px solid black", textAlign: "right", fontWeight: "bold" }}>
      Subtotal
    </TableCell> */}
    {/* <TableCell sx={{ border: "1px solid black", textAlign: "right" }}>
      ₹{total.toFixed(2)}
    </TableCell> */}
  </TableRow>

  {/* Tax Row */}
  <TableRow>
    <TableCell colSpan={6} sx={{ border: "1px solid black",borderLeft:"none", textAlign: "right", fontWeight: "bold" }}>
      GST ({invoice.tax_rate}%)
    </TableCell>
    <TableCell sx={{ border: "1px solid black",borderRight:"none", textAlign: "right" }}>
         <span style={{fontWeight:"bold"}}> ₹{total.toFixed(2)}</span>  
<br />
      ₹{tax.toFixed(2)}
    </TableCell>
  </TableRow>

  {/* Grand Total Row */}
  <TableRow>
    <TableCell colSpan={6} sx={{ border: "1px solid black",borderLeft:"none", textAlign: "right", fontWeight: "bold" }}>
      Total (incl. GST)
    </TableCell>
    <TableCell sx={{ border: "1px solid black",borderRight:"none", textAlign: "right", fontWeight: "bold" }}>
      ₹{grandTotal.toFixed(2)}
    </TableCell>
  </TableRow>
</TableBody>

  </Table>
</TableContainer>

<Typography sx={{ fontWeight: "bold", mb: 2 }}>
   {numberToWords(grandTotal)}
</Typography>

<Divider sx={{ my: 2 ,border:"2px solid black"}} />

<Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
  <Typography variant="subtitle2" sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
    Bank Details:
  </Typography>
  <Typography variant="body2" sx={{ flex: 1 }}>
    BiggBrains Solutions Pvt. Ltd.
    <br /> A/c No. 082805001848, IFSC: ICIC0000828, ICICI Bank, Rohini Sector - 24
  </Typography>
</Box>
<Box
  sx={{
    display: "flex",
    mt: 3,
    borderTop: "1px solid black",
  }}
>
  {/* Left side - Terms and Conditions */}
  <Box
    sx={{
      flex: 1,
      pr: 2,
      borderRight: "1px solid black",
      paddingRight: 2,
    }}
  >
    <Typography variant="subtitle2" sx={{ fontWeight: "bold", mb: 1 }}>
      Terms and Conditions:
    </Typography>
      <Typography variant="body2">
    E.& O.E.                                                    

    </Typography>
    <Typography variant="body2">
      1. Goods once sold will not be taken back or exchanged.
      <br />
      2. Payment due within 15 days from the invoice date.
      <br />
      3. Interest @18% p.a. will be charged on delayed payments.
      <br />
      4. Subject to Delhi jurisdiction only.
    </Typography>
  </Box>

  {/* Right side - Receiver Signature and Stamp */}
  <Box sx={{ flex: 1, }}>
    <Box
      sx={{
        borderBottom: "1px solid black",
        pb: 4,
        mb: 2,
        minHeight: "80px",
      }}
    >
      <Typography
        variant="body2"
        align="flex-start"
        sx={{ fontWeight: "bold", mt:1 }}
      >
        Receiver's Signature:
      </Typography>
    </Box>
    <Box textAlign="center">
  <Typography variant="body2" sx={{ fontWeight: "bold", mt: 2 }}>
    For BiggBrains Solutions Pvt. Ltd.
  </Typography>
 
    <img src={preetidirector} alt="Director Signature" style={{ width: "20%" }} />

  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
    Authorized Signatory 
  </Typography>
</Box>

  </Box>
</Box>

        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default InvoiceViewModal;
